import React from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Rider } from "../../types/model";

interface FeaturedRiderCardProps {
	rider: Rider;
	description?: string;
}

const FeaturedRiderCard: React.FC<FeaturedRiderCardProps> = ({
	rider,
	description,
}) => {
	const navigate = useNavigate();
	const isMobile = window.innerWidth <= 768;
	return (
		<Card className="w-100 py-4 px-3 rounded-3 text-light bg-secondary">
			<Card.Body>
				<Row>
					<Col md={8} className="d-flex flex-column justify-content-center">
						<Button
							variant="success text-white"
							className="mb-2 fw-bold rounded-pill px-3 py-0"
							style={{ width: "fit-content" }}
							size="sm"
						>
							{/* Total Points: {rider.ratings?.[0]?.rating || 0} */}
							FEATURED RIDER
						</Button>
						<h5 className="text-success fw-bold mb-1 fs-3">
							{rider.first_name} {rider.last_name}
						</h5>
						<h4 className="fw-bold text-white fs-2">
							{description || "2023 WORLD CHAMPION"}
						</h4>
						{rider?._id && (
							<Button
								onClick={() => navigate(`/riders/${rider._id}`)}
								variant="outline-light"
								className="mt-3 fw-semibold"
								style={{ width: "fit-content" }}
							>
								Athlete Profile
							</Button>
						)}
					</Col>	
					<Col
						md={4}
						className="d-flex align-items-center position-relative justify-content-center"
					>
						{isMobile ? (
							//Just show the normal image.
							<img
								src={rider?.imageUrl ?? "/images/default-rider.png"}
								alt={`${rider.first_name} ${rider.last_name}`}
								className="img-fluid rounded"
								style={{ maxHeight: "15rem" }}
							/>
						) : (
							<div
								className="position-absolute"
								style={{
									bottom: "-2.6rem",
									right: "20px",
									maxHeight: "calc(100% + 13rem)",
									overflow: "hidden",
									display: "flex",
									alignItems: "flex-end",
								}}
							>
								<img
									src={rider?.imageUrl ?? "/images/default-rider.png"}
									alt={`${rider.first_name} ${rider.last_name}`}
									className="img-fluid rounded"
									style={{ maxHeight: "20rem" }}
								/>
							</div>
						)}
					</Col>
				</Row>
			</Card.Body>
		</Card>
	);
};

export default FeaturedRiderCard;
